import { GoogleLogin } from '@react-oauth/google';
import toast from 'react-hot-toast';

import { useAuthStore } from '@/stores';

import styles from './GoogleLoginButton.module.css';

export function GoogleLoginButton() {
    const { loginWithGoogle, isLoading } = useAuthStore();

    return (
        <div className={styles.container}>
            {isLoading ? (
                <div className={styles.loading}>
                    <span className={styles.spinner} />
                    <span>Iniciando sesion...</span>
                </div>
            ) : (
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        if (credentialResponse.credential) {
                            loginWithGoogle(credentialResponse.credential);
                        }
                    }}
                    onError={() => {
                        toast.error('No se pudo iniciar sesion. Intenta de nuevo.');
                    }}
                    shape="pill"
                    size="large"
                    text="signin_with"
                    width="320"
                />
            )}
        </div>
    );
}
